<template>
  <div class="editor-footer">
    <el-button @click="handleCancel">取消</el-button>
    <el-button type="primary" @click="handleConfirm">确定</el-button>
  </div>
</template>

<script>
export default {
  name: 'EditorFooter',
  
  methods: {
    // 取消按钮点击事件处理
    handleCancel() {
      this.$emit('cancel')
    },
    
    // 确定按钮点击事件处理
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 20px;
  border-top: 1px solid #eee;

  button {
    margin-left: 10px;
  }
}
</style>